import React from 'react'
import Errors from '../errors'

const ErrorsPl = () => {
    return <Errors languageCode="pl" />
}

export default ErrorsPl
